import { api } from '../../client';

export interface VendorDto {
  id: string;
  vendor_name: string;
  display_name: string;
  email: string;
  phone: string;
  tax_id: string;
  street_address: string;
  city: string;
  state_province: string;
  postal_code: string;
  country: string;
  payment_terms: string;
  outstanding: number;
  status: string;
  created_at?: string;
  updated_at?: string;
}

export const purchasesVendorsApi = {
  async list(
    search?: string
  ): Promise<{ data?: VendorDto[]; message?: string; errors?: Record<string, string[]> }> {
    const q = search ? `?search=${encodeURIComponent(search)}` : '';
    return api.get(`/purchases/vendors${q}`) as Promise<{ data?: VendorDto[] }>;
  },

  async get(id: string): Promise<{ data?: VendorDto; message?: string }> {
    return api.get(`/purchases/vendors/${id}`) as Promise<{ data?: VendorDto }>;
  },

  async create(data: {
    vendor_name: string;
    display_name?: string;
    email?: string;
    phone?: string;
    tax_id?: string;
    street_address?: string;
    city?: string;
    state_province?: string;
    postal_code?: string;
    country?: string;
    payment_terms?: string;
    status?: string;
  }): Promise<{ data?: VendorDto; message?: string; errors?: Record<string, string[]> }> {
    return api.post('/purchases/vendors', data) as Promise<{
      data?: VendorDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async update(
    id: string,
    data: {
      vendor_name?: string;
      display_name?: string;
      email?: string;
      phone?: string;
      tax_id?: string;
      street_address?: string;
      city?: string;
      state_province?: string;
      postal_code?: string;
      country?: string;
      payment_terms?: string;
      status?: string;
    }
  ): Promise<{ data?: VendorDto; message?: string; errors?: Record<string, string[]> }> {
    return api.put(`/purchases/vendors/${id}`, data) as Promise<{
      data?: VendorDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async delete(id: string): Promise<{ success?: boolean; message?: string }> {
    return api.delete(`/purchases/vendors/${id}`) as Promise<{ success?: boolean; message?: string }>;
  },
};
